export default function AboutStory() {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
                  src="/images/k1.jpg"
          alt="Fish market interior"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-900/75" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 lg:py-20">
        <div className="max-w-4xl mx-auto">
          {/* Heading */}
          <h2 className="font-heading text-white text-3xl md:text-4xl lg:text-5xl text-center tracking-[0.2em] mb-4">
            ABOUT FINEST KIND SEAFOOD LLC
          </h2>

          {/* Horizontal Line */}
          <div className="w-24 h-0.5 bg-white/60 mx-auto mb-8 md:mb-10" />

          {/* Body Text */}
          <div className="text-white text-sm md:text-base leading-relaxed space-y-4 md:space-y-5">
            <p>
              Finest Kind Seafood LLC was founded by Brandon Vieira, a third-generation seafood professional who grew up working the docks and learning every facet of the industry from his family before him. Brandon&apos;s grandfather started as a fisherman out of New Bedford, and his father continued the tradition, building strong relationships with local fleets along the New England coast. It was only natural that Brandon would carry the torch forward.
            </p>
            <p>
              After years of working alongside his family and absorbing decades of seafood knowledge, Brandon saw an opportunity to create something different — a company built on the principles of quality, integrity, and personal relationships with both suppliers and customers. In 2020, he established Finest Kind Seafood LLC in Fall River, Massachusetts, with a simple mission: to provide the freshest, highest-quality seafood at the most competitive wholesale prices.
            </p>
            <p>
              What started as a small operation quickly gained momentum. Brandon&apos;s hands-on approach and deep understanding of the industry allowed Finest Kind Seafood LLC to rapidly expand its product line from a handful of species to a comprehensive offering that now includes swordfish, tuna, salmon, scallops, lobster, and a wide variety of other premium seafood and shellfish products. His philosophy has always been straightforward — buy directly from the best sources, handle every product with care, and treat every customer like family.
            </p>
            <p>
              Today, Finest Kind Seafood LLC operates out of a state-of-the-art facility in Fall River, strategically positioned to serve the entire Northeast corridor. The company has grown to become one of the region&apos;s most trusted seafood distributors, known for its unwavering commitment to quality and its ability to consistently deliver the freshest products day-in and day-out. Brandon&apos;s vision of becoming &ldquo;America&apos;s One-Stop-Shop for Seafood&rdquo; drives every decision the company makes.
            </p>
            <p>
              Finest Kind Seafood LLC prides itself on the relationships it has cultivated over the years. Knowing which boats to buy from, which captains consistently deliver the best quality, and maintaining transparent, fair dealings with suppliers has enabled FKS to source the finest seafood available — whether from local New England waters or from carefully vetted international partners around the globe. This dedication to quality sourcing is what sets Finest Kind apart in an increasingly competitive market.
            </p>
            <p>
              As Finest Kind Seafood LLC continues to grow, the company remains deeply rooted in the values that Brandon Vieira built it upon: hard work, integrity, and an unrelenting commitment to quality. From a small family tradition to a thriving seafood distribution enterprise, the FKS story is one of passion, perseverance, and an enduring love for the sea.
            </p>
          </div>

          {/* Organizations */}
          <div className="mt-10 md:mt-12 text-center">
            <p className="text-white text-sm md:text-base font-medium mb-6 md:mb-8">
              Finest Kind Seafood LLC is proud to be involved with a number of organizations including:
            </p>

            {/* Organization names - two columns on larger screens */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-8 text-white text-sm md:text-base mb-8 md:mb-10 max-w-2xl mx-auto">
              <div className="text-center md:text-right">Mass Seafood Collaborative</div>
              <div className="text-center md:text-left">American Scallop Association</div>
              <div className="text-center md:text-right">Save the Harbor</div>
              <div className="text-center md:text-left">Marine Stewardship Council</div>
            </div>

            
            
          </div>
        </div>
      </div>
    </section>
  );
}